<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
      <p style="text-indent: 30pt;">
        {{ "organization.create.section_4.customer_hub_section_1.customer_export" | translate }}
      </p>
      <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
        <mat-slide-toggle
          formControlName="customerExport"
          [id]="authControlKey + 'matSelectToggleCustomerExport'"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
      <p style="text-indent: 30pt;">
        {{ "organization.create.section_4.customer_hub_section_1.customer_import" | translate }}
      </p>
      <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
        <mat-slide-toggle
          formControlName="customerImport"
          [id]="authControlKey + 'matSelectToggleCustomerImport'"
        >
        </mat-slide-toggle>
      </div>
    </div>
  </div>
</div>
